<template>
  <v-container mt-7>
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col class="selectorColumn">
          <v-select
            v-model="organizations[0]"
            :items="organizations"
            label="Organizations"
            :disabled="orgDisabled"
            outlined
            dense
            clearable
          >
            <template v-slot:selection="{ item, index }">
              <span>{{ item }}</span>
              <span v-if="index === 1" class="grey--text caption">+{{ orgChoice.length - 1 }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="insChoice"
            :items="insurances"
            item-text="Insurance"
            return-object
            label="Select Insurance"
            :disabled="insDisabled"
            outlined
            dense
            clearable
            required
            :rules="[(insChoice) => insChoice.length !== 0 || 'Please select an insurance']"
            @click:clear="$nextTick(() => (insChoice = []))"
          ></v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="groupChoice"
            :items="groups"
            label="Groups"
            :disabled="groupDisabled"
            multiple
            outlined
            dense
            clearable
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item }}</div>
              <span v-if="index === 1" class="grey--text caption"
                >+{{ groupChoice.length - 1 }}</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="provChoice"
            :items="providers"
            item-text="Provide_Name"
            return-object
            label="Providers"
            :disabled="provDisabled"
            multiple
            outlined
            dense
            clearable
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item.Provide_Name }}</div>
              <span v-if="index === 1" class="grey--text caption"
                >+{{ provChoice.length - 1 }}</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="locChoice"
            :items="locations"
            item-text="Center_Location"
            return-object
            label="Locations"
            :disabled="locDisabled"
            multiple
            outlined
            dense
            clearable
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item }}</div>
              <span v-if="index === 1" class="grey--text caption">+{{ locChoice.length - 1 }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="reportChoice"
            :items="reports"
            item-text="Report Type"
            return-object
            label="Select Report"
            clearable
            outlined
            dense
            required
            :rules="[
              (reportChoice) => reportChoice.length !== 0 || 'Please select a report to run',
            ]"
            @click:clear="$nextTick(() => (reportChoice = []))"
          ></v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                label="Start Date"
                append-icon="mdi-calendar"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              :max="maxEndDate"
              show-current="false"
              type="month"
              @input="menu = false"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="selectorColumn">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                label="End Date"
                append-icon="mdi-calendar"
                outlined
                dense
                readonly
                v-on="on"
                :disabled="endDateDisabled"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              :max="maxEndDate"
              show-current="false"
              type="month"
              @input="menu2 = false"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="percentageChoice"
            :items="percentageFilter"
            return-object
            :menu-props="{ maxHeight: '400' }"
            label="Show Top %"
            outlined
            dense
            required
          ></v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-btn @click="validate" color="secondary" depressed block class="py-5">
            Run Report
            <v-icon>mdi-play</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="load" cols="12" class="text-center">
          <v-progress-circular
            color="secondary"
            indeterminate
            :size="50"
            :width="3"
          ></v-progress-circular>
        </v-col>

        <v-col
          v-else-if="(insChoice.length === 0 || reportChoice.length === 0) && !showReport"
          cols="12"
        >
          <v-alert :value="true" type="info"> Please select all required fields </v-alert>
        </v-col>
        <v-col v-else-if="insChoice.length > 0 && reportChoice.length > 0 && !hasRun" cols="12">
          <v-alert :value="true" type="info"> Press run report to continue </v-alert>
        </v-col>
        <v-col v-else-if="showReport && changeDetected && hasRun" cols="12">
          <v-alert :value="true" type="warning">
            Change detected: Run the report to see updated data
          </v-alert>
        </v-col>
        <v-col v-else-if="reportData.length === 0 && showReport" cols="12">
          <v-alert :value="true" type="info">
            There is no data available for this selection. Please change your filter selections and
            run report again
          </v-alert>
        </v-col>
      </v-row>
    </v-form>

    <v-row v-if="this.reportChoice !== 'Risk Report'">
      <AIReports
        :organizations="orgChoice"
        :groups="groupNum"
        :providers="provChoice"
        :locations="locChoice"
        :insurance="selectedInsurance"
        :startDate="startDate"
        :endDate="endDate"
        :reportType="reportChoice"
        :data="reportData"
        :csvData="csvData"
        :reportLimit="reportLimit"
      />
    </v-row>

    <v-row v-else-if="this.reportChoice === 'Risk Report'">
      <RiskReport
        :organizations="orgChoice"
        :groups="groupNum"
        :providers="provChoice"
        :locations="locChoice"
        :insurance="selectedInsurance"
        :startDate="startDate"
        :endDate="endDate"
        :reportType="reportChoice"
        :data="reportData"
        :csvData="csvData"
        :reportLimit="reportLimit"
      />
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import AIReports from '../components/aiReports/AIReports';
import RiskReport from '../components/aiReports/RiskReport';

export default {
  components: {
    AIReports,
    RiskReport,
  },
  data() {
    return {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1)
        .toISOString()
        .substr(0, 7),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1)
        .toISOString()
        .substr(0, 7),
      maxEndDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1)
        .toISOString()
        .substr(0, 7),
      menu: false,
      modal: false,
      menu2: false,
      tab: null,
      user: '',
      orgChoice: [],
      groupChoice: [],
      provChoice: [],
      locChoice: [],
      insChoice: [],
      reportChoice: [],
      organizations: [],
      providers: [],
      groups: [],
      groupObject: [],
      groupNum: [],
      insurances: [],
      locations: [],
      reportData: [],
      csvData: [],
      reportLimit: 0.05,
      percentageFilter: ['5%', '10%', '25%', '50%', '100%'],
      percentageChoice: '5%',
      reports: [
        'High Probability All Cost',
        'High Probability RX Cost',
        'Risk of Hospitalization',
        'Risk of Readmission',
        'Risk Report',
        'Pharmacy Predicted Cost Risk',
        'Predicted Cost Risk',
      ],
      showReport: false,
      changeDetected: false,
      hasRun: false,
      load: false,
      selectedInsurance: [],
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.getReport();
      }
    },
    getReport() {
      this.selectedInsurance = this.insChoice;
      this.load = true;
      const provNums = this.provChoice;
      const locs = this.locChoice;

      let providers = [];
      let locations = [];

      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      if (this.locChoice.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      if (this.insChoice.length != 0 && this.reportChoice.length != 0) {
        this.load = true;
        this.reportData = [];
        this.filteredData = [];
        this.riskToggle = 'all';

        const response = axios
          .get(
            `api/ai/reports/${this.reportChoice}/orgs=${this.orgChoice}/groups=${this.groupNum}/providers=${providers}/locs=${locations}/${this.insChoice}/${this.startDate}/${this.endDate}/${this.reportLimit}`,
            { cancelToken: this.cancelSource.token }
          )
          .then((response) => {
            this.reportData = response.data;
            this.csvData = JSON.parse(JSON.stringify(this.reportData));
            this.csvData.forEach((obj) => {
              delete obj._id;
              delete obj.ID;
            });
            this.showReport = true;
            this.load = false;
            this.cancelSource = null;
            this.changeDetected = false;
            this.hasRun = true;
          });
      }
    },
    async checkPresets() {
      if (this.user.role === 'Provider' || this.user.role === 'Group') {
        this.setPresets();
      } else if (this.user.role === 'Clinical') {
        this.$router.push('/membership');
      } else {
        this.getOrgs();
        this.getInsurances();
      }
    },
    async setPresets() {
      this.organizations = this.user.organization;
      this.groups = this.user.group;
      this.insurances = this.user.insurance;

      if (this.user.role === 'Provider') {
        this.insChoice = this.user.insurance[0];
        this.orgChoice = this.user.organization;
        this.groupChoice = this.user.group;
        this.providers = this.user.provider;
        this.location = this.user.location;
      } else if (this.user.role === 'Group') {
        this.orgChoice = this.user.organization;
        this.insChoice = this.user.insurance[0];
      }
    },
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
        })
        .catch((err) => this.$router.push('/login'));
      this.checkPresets();
    },
    async getOrgs() {
      const response = await axios.get('api/list/organization').then((response) => {
        this.organizations = response.data;
        this.orgChoice = this.organizations[0];
      });
    },
    async getInsurances() {
      const response = await axios.get('api/list/insurances').then((response) => {
        this.insurances = response.data;
      });
    },
    async getGroups() {
      if (this.insChoice.length > 1) {
        const response = await axios.get(`api/list/${this.insChoice}/groups`).then((response) => {
          this.cancelSource = null;
          this.groups = response.data;
        });
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  watch: {
    percentageChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      if (this.percentageChoice === '5%') {
        this.reportLimit = 0.05;
      }
      if (this.percentageChoice === '10%') {
        this.reportLimit = 0.1;
      }
      if (this.percentageChoice === '25%') {
        this.reportLimit = 0.25;
      }
      if (this.percentageChoice === '50%') {
        this.reportLimit = 0.5;
      }
      if (this.percentageChoice === '100%') {
        this.reportLimit = 1;
      }
    },
    async groupChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      if (this.groupChoice.length > 0) {
        this.providers = [];
        this.provChoice = [];
        this.locations = [];
        this.locChoice = [];
        this.groupNum = [];

        // Check for pending request and if so cancel old one for new incoming
        this.cancelSearch();
        // Set the CancelToken
        this.cancelSource = axios.CancelToken.source();

        const response = await axios
          .get(`api/selection/${this.insChoice}/group/${this.groupChoice}`, {
            cancelToken: this.cancelSource.token,
          })
          .then((response) => {
            // Set cancelsource back to null
            this.cancelSource = null;
            const { data } = response;
            this.groupObject = data;
            data.forEach((element) => {
              if (this.user.role === 'Provider') {
                if (this.user.provider.includes(element.Provide_Name)) {
                  this.providers.push(element);
                  this.provChoice.push(element);
                }
              } else {
                this.providers.push(element);
              }
              if (this.insChoice) {
                if (this.groupNum.indexOf(element.Center_PCP_Number) === -1) {
                  this.groupNum.push(element.Center_PCP_Number);
                }
              }
            });
          });
      } else {
        this.providers = [];
        this.provChoice = [];
        this.locChoice = [];
        this.locations = [];
        this.groupNum = [];
      }
    },
    async provChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      if (this.provChoice !== []) {
        const prov = this.provChoice;
        let allProviders = this.providers;
        let providerNames = [];
        this.locations = [];
        this.locChoice = [];

        // Create an Array of selected provider names
        prov.forEach((provs) => {
          providerNames.push(provs.Provide_Name);
        });
        // Loop through all the providers objects and see if there is a match with any names in providerNames array
        allProviders.forEach((p) => {
          if (providerNames.indexOf(p.Provide_Name) !== -1) {
            // Add the location
            if (p.Center_Location !== null) {
              this.locations.push(p.Center_Location);
            } else {
              this.locations.push(p.Center_PCP_Number + '- No Location Provided');
            }
          }
        });
      } else {
        this.locChoice = [];
        this.locations = [];
      }
    },
    async insChoice() {
      this.groupChoice = [];
      this.provChoice = [];
      this.locChoice = [];
      if (this.showReport) {
        this.changeDetected = true;
      }

      if (this.user.role === 'Admin' || this.user.role === 'Superuser') {
        if (this.insChoice !== []) {
          this.getGroups();
        }
      } else {
        this.insurances = this.user.insurance;

        if (this.user.role === 'Provider') {
          this.groupChoice = this.user.group;
        }
      }
    },
    startDate() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    endDate() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    locChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    reportChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    async data() {
      this.reportData = this.data;
    },
  },
  computed: {
    endDateDisabled() {
      if (
        this.reportChoice === 'Risk of Readmission' ||
        this.reportChoice === 'Risk of Hospitalization' ||
        this.reportChoice === 'Predicted Cost Risk' ||
        this.reportChoice === 'High Probability RX Cost' ||
        this.reportChoice === 'High Probability All Cost' ||
        this.reportChoice === 'Risk Report'
      ) {
        return true;
      }
      return false;
    },
    orgDisabled() {
      if (this.user.role === 'Provider' || this.user.role === 'Group') {
        return true;
      }
      return false;
    },
    insDisabled() {
      if (this.user.role === 'Provider' || this.insurances.length == 1) {
        return true;
      }
      return false;
    },
    provDisabled() {
      if (this.groupChoice.length === 0) {
        this.provChoice = [];
        return true;
      }
      if (this.user.role === 'Provider') {
        return true;
      }
      return false;
    },
    locDisabled() {
      if (
        this.provChoice.length === 0 ||
        this.groupChoice.length === 0 ||
        this.insChoice === 'Humana'
      ) {
        this.locChoice = [];
        return true;
      }
      return false;
    },
    groupDisabled() {
      if (this.orgChoice.length === 0 || this.insChoice.length === 0) {
        this.groupChoice = [];
        return true;
      }
      if (this.user.role === 'Provider') {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.newSelect .v-select__selection {
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selection-text {
  margin-right: 5px;
}
@media only screen and (min-width: 1200px) {
  .selection-text {
    white-space: nowrap;
    overflow: hidden;
    width: 70%;
  }
}
</style>
